import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import DocumentMeta from 'react-document-meta';

import $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Templates from './pages/Templates';
import CallbackPage from './pages/CallbackPage';
import ApplicationsPage from './pages/ApplicationsPage';
import Workflows from './pages/Workflows';
import GoogleAnalytics from './components/GoogleAnalytics';
import ErrorPage from './pages/ErrorPage'

import { getJson, postJson } from './helpers/RequestsHelper'
import SearchPage from './pages/Search';

import Survey1 from './pages/surveys/Survey1';
import Survey2 from './pages/surveys/Survey2';
import Survey3 from './pages/surveys/Survey3';

import ProtectedRoute from './components/ProtectedRoute'

import {
  CognitoUserPool
} from "amazon-cognito-identity-js";

import SignUpPage from './pages/user/SignUpPage';
import SignOutPage from './pages/user/SignOutPage';
import ConfirmationCodePage from './pages/user/ConfirmationCodePage';
import LoginPage from './pages/user/LoginPage';
import ForgottenPasswordPage from './pages/user/ForgottenPasswordPage';
import ProfilePage from './pages/user/ProfilePage';
import RewardsPage from './pages/user/RewardsPage';
import VerifyEmailPage from './pages/user/VerifyEmailPage';
import VerifyPhonePage from './pages/user/VerifyPhonePage';
import ChangePasswordPage from './pages/user/ChangePassword';
import Workflow from './pages/Workflow';
import HeaderMenu from './components/HeaderMenu';


import { initializeApps } from './helpers/applications'
import CommuteCalculatorTool from './pages/tools/CommuteCalculatorTool';
import metaTags from './helpers/metaTags';
import CryptoActivityTrackerTool from './pages/tools/CryptoActivityTrackerTool';
import CryptoRangeTrackerTool from './pages/tools/CryptoRangeTrackerTool';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AuthPage from './pages/user/AuthPage';
import Authorization from './pages/user/Authorization';
import { globalState, timezones } from './helpers/constants';
import WorkflowStart from './pages/WorkflowStart';
import Office from './pages/Office';
import MeetingsPage from './pages/MeetingsPage'
import { Helmet } from 'react-helmet';

let theme = createTheme({
  palette: {
    primary: {
      main: '#d01a62',
    },
    secondary: {
      main: '#dddddd'
    }
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
    fontSize: 14,
  }
})

//Google Analytics integration
window.gtag('config', process.env.REACT_APP_GA_TRACKING_ID)

window.onerror = function (msg, url, line, col, error) {
  window.gtag('event', 'exception', {
    'description': msg,
    'fatal': false
  });
  var json = { msg, url, line, col, stack: error.stack }
  postJson(process.env.REACT_APP_SERVER_BASE_URL + "/error", json)
};

window.userPool = new CognitoUserPool({
  UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
  ClientId: process.env.REACT_APP_COGNITO_CLIENTID,
});


class App extends Component {

  static getDerivedStateFromProps(props, state) {
    //TODOLATER: Is there a better approach?
    if (window.location.pathname.startsWith("/myapps")) {
      state["selected"] = "myapps"
    } else if (window.location.pathname.startsWith("/flow")) {
      state["selected"] = "flows"
    } else if (window.location.pathname.startsWith("/workflows")) {
      state["selected"] = "workflows"
    } else if (window.location.pathname.startsWith("/user/signout")) {
      state["selected"] = "signout"
    } else if (window.location.pathname.startsWith("/tools")) {
      state["selected"] = "tools"
    }
    return state
  }

  state = {
    selected: "home",
    expanded: false,
    loading: true,
    rewards: undefined,
    onboarding: false,
    isLegacy: false,
    windowWidth: 0
  }

  constructor() {
    super();
    this.onboardingUpdate = this.onboardingUpdate.bind(this);
    this.handleSessionRetrieved = this.handleSessionRetrieved.bind(this)
    this.handleResize = this.handleResize.bind(this)
    this.toggleLegacy = this.toggleLegacy.bind(this)
    this.loadRewards = this.loadRewards.bind(this)
    this.state.windowWidth = window.innerWidth
  }

  componentDidMount() {
    this.initialize(this.props.provider);
    window.addEventListener("resize", this.handleResize);
  }

  async initialize() {
    const cognitoUser = window.userPool.getCurrentUser()
    let loading = true

    if (cognitoUser) {
      cognitoUser.getSession((err, session) => this.handleSessionRetrieved(err, session, cognitoUser))
    } else {
      await initializeApps()
      loading = false
    }

    let initialOnboarding = false
    var searchParams = new URLSearchParams(window.location.search)
    if (searchParams) {
      initialOnboarding = searchParams.get("onboarding")
    }
    //TODO: Find better way
    window.loadRewards = this.loadRewards
    await this.loadRewards()
    const fullScreen = window.location.pathname.startsWith("/office") 
    const className = fullScreen ? "App" : "App container"
    const style = fullScreen
      ? { height: '100%', width: '100%', padding: '0px', display: 'flex', flexDirection: 'column', flex: 1 }
      : { height: '90%', width: '100%', padding: '20px', display: 'flex', flexDirection: 'column', flex: 1 }

    const menu = window.self === window.top && !fullScreen
    this.setState(({ loading, menu, fullScreen, className, style, initialOnboarding }));
  }

  async handleSessionRetrieved(err, session, cognitoUser) {

    cognitoUser.getUserAttributes(function (err, result) {
      if (result) {
        for (let i = 0; i < result.length; i++) {
          const value = result[i].getValue()
          switch (result[i].getName()) {
            case "zoneinfo": globalState.user = { zoneinfo: timezones.find(a => a.id === value) }; break;
            default: break;
          }
        }
      }
    })

    if (err) {
      console.log("User is not logged in!")
    } else {
      console.log("User is logged in!")
      await initializeApps()
      await this.loadOnboarding()
    }
    await this.loadRewards()
    this.setState({ loading: false })
  }

  getMetaForPage() {
    var pathArray = window.location.pathname.split('/');
    var page = pathArray[pathArray.length - 1]
    if (metaTags[page] !== undefined) {
      return metaTags[page]
    } else {
      return metaTags.default
    }
  }

  async loadRewards() {
    let rewards = {}
    if (!window.userPool.getCurrentUser()) {
      window.availableReward = <div className="apps-group" style={{ textAlign: "center" }}>
        <>Win <b>100 $TIME</b> and 1 ticket for a <b>$20 Amazon gift card</b> raffle!<br /><a href='/user/signup' target='_blank'>Sign up now!</a>
          <br /><small>Only available to the next 50 new users. No purchase necessary to enter or win.</small></>
      </div>
    } else {
      const path = process.env.REACT_APP_SERVER_BASE_URL + "/rewards"
      rewards = await getJson(path)
    }
    this.setState({ rewards })
  }

  async loadOnboarding() {

    const path = process.env.REACT_APP_SERVER_BASE_URL + "/onboarding"
    const result = await getJson(path)

    const onboarding = this.state.initialOnboarding

    if (!result || !result.onboarding || !result.onboarding.includes(onboarding)) {
      this.setState({ onboarding })
    }
  }

  async onboardingUpdate(onboarding) {
    if (this.state.onboarding && onboarding === false) {
      await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/updateProfile", { onboarding: this.state.onboarding });
    }
    this.setState({ onboarding })
  }

  toggleLegacy = () => {
    this.setState({ isLegacy: !this.state.isLegacy })
  }

  handleResize = (e) => {
    this.setState({ windowWidth: window.innerWidth });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    if (this.state.loading) {
      return <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    }
    const { selected } = this.state;

    //var meta = this.getMetaForPage()
//<DocumentMeta {...meta}>
    return (<>        
        <Helmet>
            <title>Simply Flows</title>
            <meta name='description' content='Our mission is to empower people &amp; organizations by eliminating repetitive tasks and increasing efficiency &amp; productivity. We are building the future of work: empowering knowledge workers by automation to unleash creativity &amp; drive innovation.' />
        </Helmet>
        <ThemeProvider theme={theme}>
          <Router>
            {this.state.menu ? <HeaderMenu windowWidth={this.state.windowWidth} rewards={this.state.rewards} /> : <></>}
            <div className={this.state.className} style={this.state.style}>
              <Route render={({ location, history }) => (
                <React.Fragment>

                  <Switch>
                    <Route path="/error" component={ErrorPage} windowWidth={this.state.windowWidth} />
                    <Route path="/user/login" component={LoginPage} windowWidth={this.state.windowWidth} />
                    <Route path="/user/auth" component={AuthPage} windowWidth={this.state.windowWidth} />
                    <Route path="/user/authorization" component={Authorization} windowWidth={this.state.windowWidth} />
                    <Route path="/user/signup" component={SignUpPage} windowWidth={this.state.windowWidth} />
                    <Route path="/user/forgottenpassword" component={ForgottenPasswordPage} windowWidth={this.state.windowWidth} />

                    <Route path="/survey/1" component={Survey1} windowWidth={this.state.windowWidth} />
                    <Route path="/survey/2" component={Survey2} windowWidth={this.state.windowWidth} />
                    <Route path="/survey/3" component={Survey3} windowWidth={this.state.windowWidth} />
                    <Route path="/tools/commute-calculator" component={CommuteCalculatorTool} windowWidth={this.state.windowWidth} />
                    <Route path="/tools/crypto-activity-tracker" component={CryptoActivityTrackerTool} windowWidth={this.state.windowWidth} />
                    <Route path="/tools/crypto-range-tracker" component={CryptoRangeTrackerTool} windowWidth={this.state.windowWidth} />

                    <Route path="/office" component={Office} windowWidth={this.state.windowWidth} />

                    {/* Protected pages */}
                    <Route path="/user/confirmation" component={ConfirmationCodePage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/user/verifyemail" component={VerifyEmailPage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/user/verifyphone" component={VerifyPhonePage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/user/profile" component={ProfilePage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/user/rewards" component={RewardsPage} windowWidth={this.state.windowWidth} loadRewards={this.loadRewards} rewards={this.state.rewards} />
                    <ProtectedRoute path="/user/changepassword" component={ChangePasswordPage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/search" component={SearchPage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/myapps" component={ApplicationsPage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/workflows" component={Workflows} onboarding={this.state.onboarding} onboardingUpdate={this.onboardingUpdate} windowWidth={this.state.windowWidth} />
                    <Route path="/templates" component={Templates} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/oauth/callback" component={CallbackPage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/user/signout" component={SignOutPage} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/workflow/template/:templateId" component={Workflow} onboarding={this.state.onboarding} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/workflow/copy/:copyId" component={Workflow} onboarding={this.state.onboarding} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/workflow/:id" component={Workflow} onboarding={this.state.onboarding} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/workflow" component={Workflow} onboarding={this.state.onboarding} windowWidth={this.state.windowWidth} />
                    <ProtectedRoute path="/create" component={WorkflowStart} onboarding={this.state.onboarding} windowWidth={this.state.windowWidth} />

                    <ProtectedRoute path="/meetings" component={MeetingsPage} windowWidth={this.state.windowWidth} />
                    <Route exact path="/">
                      <Redirect to="/templates" />
                    </Route>
                  </Switch>
                  <GoogleAnalytics />
                </React.Fragment>
              )}
              />
            </div>
          </Router>
        </ThemeProvider>
        </>
    );
  }

}

export default App;
